/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: #f0f;
  }
`

export default class PointIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" css={Color}>
          <path
            id="icon_point"
            d="M-395-2101a39.568,39.568,0,0,1-15.333-2.847,39.571,39.571,0,0,1-12.933-8.808,39.285,39.285,0,0,1-8.867-12.847A38.843,38.843,0,0,1-435-2140.735a41.062,41.062,0,0,1,2.867-15.5,39.324,39.324,0,0,1,8.867-13.113,39.584,39.584,0,0,1,12.933-8.807A39.564,39.564,0,0,1-395-2181a39.569,39.569,0,0,1,15.334,2.848,39.578,39.578,0,0,1,12.934,8.807,39.326,39.326,0,0,1,8.866,13.113,41.067,41.067,0,0,1,2.867,15.5,38.314,38.314,0,0,1-11.732,28.079,39.563,39.563,0,0,1-12.934,8.808A39.573,39.573,0,0,1-395-2101Zm-13.856-61.332v42.286h8.456v-15.029h5.657c4.731,0,8.735-1.168,11.579-3.378,3.162-2.457,4.765-6.031,4.765-10.622,0-8.8-5.575-13.256-16.572-13.256Zm13.542,20.571H-400.4v-13.886h4.8c6.248,0,8.914,1.965,8.914,6.571a6.844,6.844,0,0,1-2.128,5.479C-390.239-2142.379-392.426-2141.761-395.314-2141.761Z"
            transform="translate(435.001 2181.001)"
            fill="#f0f"
          />
        </svg>
      </Fragment>
    )
  }
}
